import React, { FC } from 'react'

import { privateRoutes } from '@app/routes'
import { RenderRoutes } from '@common/Routing'
import EnvelopeOverlayContext from '@common/Routing/EnvelopeOverlayContext'
import { IEnvelopeOverlayLocationState } from '@common/Routing/types'
import { useAppSelector } from '@hooks/redux'
import { Path } from '@const/paths'

import { Layout, Loader } from '@infologistics/frontend-libraries'
import {
  UNSAFE_LocationContext as LocationContext,
  useLocation,
  useNavigationType,
} from 'react-router-dom'

const envelopeOverlayRoutes = privateRoutes.filter(({ path }) =>
  path === Path.ENVELOPE || path === Path.ENVELOPE_BUSINESS
)

const LayoutWrapper: FC = () => {
  const location = useLocation()
  const navigationType = useNavigationType()
  const { pathname } = location
  const backgroundLocation = (
    location.state as IEnvelopeOverlayLocationState | null
  )?.backgroundLocation
  const listLocation = backgroundLocation ?? location
  const { isLoading } = useAppSelector((state) => state.loader)
  const { isHeaderVisible, isMenuVisible } = useAppSelector((state) => state.utils)
  const isEnvelopeWorkspaceRoute = (
    pathname === Path.ENVELOPE_NEW ||
    (/^\/envelope\/[^/]+$/.test(pathname) && pathname !== Path.ENVELOPE_NEW) ||
    /^\/envelopes\/[^/]+\/envelope\/[^/]+$/.test(pathname)
  )

  const layoutClasses = [
    !isMenuVisible && 'fl-layout-full',
    !isHeaderVisible && 'fl-layout-no-header',
    isEnvelopeWorkspaceRoute && 'fl-layout-overlay'
  ].filter(Boolean).join(' ') || undefined

  return (
    <Layout externalClass={layoutClasses}>
      <EnvelopeOverlayContext.Provider value={Boolean(backgroundLocation)}>
        {/* React Router 6.3 does not scope useLocation when Routes.location is overridden. */}
        <LocationContext.Provider
          value={{ location: listLocation, navigationType }}
        >
          <RenderRoutes routes={privateRoutes} />
        </LocationContext.Provider>
      </EnvelopeOverlayContext.Provider>
      {backgroundLocation && (
        <RenderRoutes routes={envelopeOverlayRoutes} />
      )}
      <Loader loading={isLoading} />
    </Layout>
  )
}

export default LayoutWrapper
